import React from 'react';
import { TextInput } from '../ui';

function SeasonSetupView({
  players,
  seasonSetupForm,
  setSeasonSetupForm,
  seasonSetupPlayerId,
  setSeasonSetupPlayerId,
  createSeasonFromSetup,
  setView,
  setPlayerEditMode,
  setActivePlayerId
}) {
  return (
    <section className="card auth-card" style={{ marginBottom: "40px" }}>
      <h2 className="section-title">Create Season</h2>

      {players.length === 0 ? (
        <>
          <div className="muted" style={{ marginBottom: 8 }}>
            You don't have any players yet.
          </div>
          <div className="actions">
            <button className="btn btn-primary" onClick={() => {
              setActivePlayerId(null);
              setPlayerEditMode("create");
              setView("player-setup");
            }}>
              Add Player
            </button>
            <button className="btn btn-muted" onClick={() => setView("dashboard")}>
              Back to Dashboard
            </button>
          </div>
        </>
      ) : (
        <form onSubmit={createSeasonFromSetup} className="auth-form">
          {players.length > 1 ? (
            <label className="field">
              <span className="field-label">Player</span>
              <select
                className="input"
                value={seasonSetupPlayerId || ""}
                onChange={(e) => setSeasonSetupPlayerId(e.target.value)}
                required
              >
                {players.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                    {p.number ? ` (#${p.number})` : ""}
                    {p.team ? ` — ${p.team}` : ""}
                  </option>
                ))}
              </select>
            </label>
          ) : (
            <TextInput label="Player" value={players[0]?.name || ""} onChange={() => {}} disabled />
          )}

          <TextInput
            label="Season name"
            value={seasonSetupForm.name}
            onChange={(v) => setSeasonSetupForm((s) => ({ ...s, name: v }))}
            placeholder="e.g., 2025 Varsity"
          />
          <TextInput
            label="Team (optional)"
            value={seasonSetupForm.team}
            onChange={(v) => setSeasonSetupForm((s) => ({ ...s, team: v }))}
            placeholder="e.g., Lincoln High School"
          />
          <TextInput
            label="Year (optional)"
            value={seasonSetupForm.year}
            onChange={(v) => setSeasonSetupForm((s) => ({ ...s, year: v }))}
            placeholder="2025"
          />

          <div className="actions">
            <button
              className="btn btn-primary"
              type="submit"
            >
              Create Season
            </button>
            <button
              className="btn btn-muted"
              type="button"
              onClick={() => setView("dashboard")}
            >
              Cancel
            </button>
          </div>
        </form>
      )}
    </section>
  );
}

export default SeasonSetupView;
